<template>
    <div>
        <p>
            A comunicação da Chico Rei é o casamento perfeito entre imagens e textos, onde um tem o
            papel de elevar o outro.
        </p>
        <p>
            Preferencialmente, trabalhamos com as fotografias como informações principais. Elas, por
            sua vez, devem dar suporte para que os textos sejam curtos, lúdicos e criativos ao
            transmitirem a mensagem objetivada de forma clara e direta.
        </p>
        <p>
            O processo de comunicação digital é pautado pela economia da atenção. Portanto, devemos
            conquistar o olhar e o tempo do usuário em um breve olhar. As fotos devem sobressair nas
            peças, trazendo o impacto visual necessário.
        </p>
        <p>
            Os textos, ainda que importantes, aparecem de forma secundária, casando com as imagens e
            entregando informações essenciais e/ou complementares ao que está posto de forma
            figurativa.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookHierarchy',
    };
</script>
